import { render } from "./PagePoster.vue?vue&type=template&id=57a89102"
import script from "./PagePoster.vue?vue&type=script&lang=js"
export * from "./PagePoster.vue?vue&type=script&lang=js"

import "./PagePoster.vue?vue&type=style&index=0&id=57a89102&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__